import React from 'react'
import logo from '../assets/images/logo.png';

const Us = (props) => {
    return (
        <img src={logo} />
    )
}

export default Us;



// WEBPACK FOOTER //
// ./src/components/Logo.js